var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button is-primary is-small",on:{"click":_vm.open}},[_vm._v(" Abrir Buscador ")]),_c('br'),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }